import { BaseHover } from './base';
import { HoverType } from '../types';
import { css } from '../../emotion';
export class Skew extends BaseHover {
    constructor(option) {
        super(HoverType.Skew);
        this.x = (option === null || option === void 0 ? void 0 : option.skewX) || 0;
        this.y = (option === null || option === void 0 ? void 0 : option.skewY) || 0;
        if (this.x === 0 && this.y === 0) {
            this.x = -20;
        }
    }
    animateProps() {
        return {
            from: this.generateProps({
                skewX: '0deg',
                skewY: '0deg',
                transform: 'perspective(1px) translateZ(0)',
                transformOrigin: '0% 100%'
            }),
            to: this.generateProps({ skewX: `${this.x}deg`, skewY: `${this.y}deg` }),
            loop: {
                skewX: '0deg',
                skewY: '0deg',
                reverse: true
            }
        };
    }
    cssProps() {
        return css `
      display: inline-block;
      vertical-align: middle;
      box-shadow: 0 0 1px rgba(0, 0, 0, 0);
      transition-duration: 0.3s;
      transition-property: transform;
      transform-origin: 0 100%;

      &:hover, &:focus, &:active {
        transform: perspective(1px) translateZ(0) skew(${this.x}deg, ${this.y}deg);
      }
    `;
    }
}
